import { render } from "./SpotifyPlaylist.vue?vue&type=template&id=25d3a8f7"
const script = {}

import "./SpotifyPlaylist.vue?vue&type=style&index=0&id=25d3a8f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__